import { Injectable, Type } from '@angular/core';
import { AjaxService } from './ajax.service';

export class Download {
  href: string;
  title: string;
}

@Injectable({
    providedIn: 'root',
})
export class DownloadService {
    constructor(private ajax: AjaxService) {}

      public async getDownloads(isLegal: boolean = false): Promise<Download[]> {
        return await this.ajax.post('/downloads/getDownloads', { isLegal: isLegal });
    }
}